<script lang="ts">
	import { format } from 'svelte-i18n';
	import { ToggleV2 } from '@Shelly/shelly-design-system';
	import { user_data } from 'src/stores/account/user';
	import { accessibleVirtualDevices } from 'src/helpers/virtual_helpers/virtual_components_helpers';
	import PremiumUpsellAlert from 'src/components/Premium/PremiumUpsellAlert.svelte';

	export let extractAsDevice: boolean;
	export let showModal: boolean;
	export let disabled = false;

	const extractedAsDevice = !extractAsDevice;
</script>

{#if !$user_data.premium}
	<PremiumUpsellAlert
		class="mb-s"
		heading={$format('heading_alert_get_premium_virtual_devices', {
			default: 'To extract more than one virtual group as device, you need to be a premium user.',
		})}
		onGetPremium={() => {
			showModal = false;
		}}
	/>
{/if}
<ToggleV2
	size="m"
	class="mb-s"
	bind:checked={extractAsDevice}
	disabled={disabled || (extractedAsDevice && !accessibleVirtualDevices())}
	id="toggle-dwrz4ha"
>
	{$format('settings_group_virtual_component_extract_as_device', {
		default: 'Extract virtual group as device',
	})}
</ToggleV2>
